import { sleep } from "@/shared/utils";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { api } from "@/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Caja } from "@/shared/types/caja";

export interface CajaAddRequest {
    nombre: string,
}

export async function addCaja(request: CajaAddRequest): Promise<Caja> {
    await sleep(1000);
    const response = await api.post("cajas", request);
    return response.data;
}

export function useAddCajaMutation(mutationConfig: MutationConfig<Caja, CajaAddRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: addCaja,
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["cajas"] });
        },
    })
}

export interface AddCajaMutationProps {
    mutationConfig?: MutationConfig<Caja, CajaAddRequest>
    children?: (mutationResult: MutationResult<Caja, CajaAddRequest>) => ReactNode
}

export function AddCajaMutation({
    mutationConfig,
    children
}: AddCajaMutationProps) {
    const mutationResult = useAddCajaMutation(mutationConfig);
    return children && children(mutationResult);
}